"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Crown, Quote } from "lucide-react";
import { Carousel, CarouselContent, CarouselItem, CarouselNext, CarouselPrevious } from "@/components/ui/carousel";
import { Card, CardContent } from "@/components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const testimonials = [{
  author: "Alex Rivers",
  quote: "Werkys automated our entire workflow in days. The speed and agility are absolutely cat-like.",
  position: "CTO, CloudScale AI",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/avatar_jane_d.png"
}, {
  author: "Sarah Chen",
  quote: "The AI generation tools are incredibly intuitive. We've scaled our platform content by 10x since switching.",
  position: "Head of Growth, Nexa SaaS",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/avatar_mark_p.png"
}, {
  author: "Marcus Thorne",
  quote: "The most playful yet powerful platform I've ever used. Our team actually enjoys managing complex tasks now.",
  position: "Product Lead, FlowState",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1636683/img/avatar_sarah_l.png"
}];
export default function ClientSuccessStories() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="221817" id="success-stories" className="bg-background text-foreground py-24 md:py-32 overflow-hidden" ref={ref}>
      <div className={`container mx-auto px-4 md:px-6 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <div className="mb-16 md:mb-24 flex flex-col items-center text-center">
          <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold font-default uppercase tracking-tighter mb-6">
            Success Stories
          </h2>
          <div className="h-1.5 w-24 bg-primary"></div>
        </div>

        <Carousel opts={{
        align: "center",
        loop: true
      }} className="w-full max-w-6xl mx-auto">
          <CarouselContent>
            {testimonials.map((testimonial, i) => <CarouselItem key={i} data-index={i}>
                <Card className="bg-card border-none rounded-3xl p-8 md:p-16 relative shadow-sm">
                  <Quote className="absolute top-8 right-8 md:top-16 md:right-16 w-24 h-24 md:w-40 md:h-40 text-primary/5 rotate-180 pointer-events-none" />
                  
                  <CardContent className="p-0 flex flex-col items-center text-center gap-8 md:gap-12 relative z-10">
                    <div className="flex gap-2 text-primary">
                      {[...Array(5)].map((_, j) => <Crown key={j} className="w-6 h-6 md:w-8 md:h-8 fill-current" />)}
                    </div>

                    <p className="text-2xl md:text-4xl lg:text-5xl font-serif font-medium leading-tight md:leading-tight text-foreground max-w-4xl">
                      "{testimonial.quote}"
                    </p>

                    <div className="flex flex-col items-center gap-6 mt-4">
                      <SafeHydrate><Avatar className="w-24 h-24 md:w-32 md:h-32 border-4 border-primary rounded-full p-1 bg-background">
                        <AvatarImage src={testimonial.image} alt={testimonial.author} className="rounded-full object-cover" />
                        <AvatarFallback className="font-mono text-2xl bg-muted text-muted-foreground rounded-full">
                          {testimonial.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      
                      <div className="space-y-2">
                        <h4 className="font-default text-xl md:text-2xl font-bold text-foreground uppercase tracking-wider">
                          {testimonial.author}
                        </h4>
                        <p className="font-mono text-sm md:text-base text-primary uppercase tracking-widest">
                          {testimonial.position}
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </CarouselItem>)}
          </CarouselContent>
          
          <div className="flex justify-center gap-4 mt-12">
            <CarouselPrevious className="static translate-y-0 translate-x-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary rounded-none w-14 h-14 transition-colors" />
            <CarouselNext className="static translate-y-0 translate-x-0 border-primary text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary rounded-none w-14 h-14 transition-colors" />
          </div>
        </Carousel>
      </div>
    </section>;
}